module.exports = __webpack_public_path__ + "static/media/smilemoons.35fc5da3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smilemoons.svg
// module id = 516
// module chunks = 0